import { auth, db } from "../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";

// Function to save form data for Section 8
export const writeDataS10 = async (formData) => {
  const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Unemployment Details"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 10 data saved successfully.");
  } catch (error) {
    // console.error("Error writing Section 8 data to Firestore: ", error);
  }
};
